export function postTypingNotificationMessage(portalBaseUrl: string, dealerId: string, conversationId: string, lastTimeTyped: number): Promise<void> {
	return fetch(`${portalBaseUrl}/api/bot/${dealerId}/conversations/${conversationId}/typing/${lastTimeTyped}`, {method: 'post'})
		.then(response => {
			if (!response.ok) {
				throw Error(response.statusText);
			}
			return response.json();
		});
}
